// extracted by mini-css-extract-plugin
export default {"frame":"Landing_frame__Za67+"};